var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReservationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.965 22.542 26.843 8.847a1.373 1.373 0 0 0-1.339-1.068H6.475a.858.858 0 0 0-.836 1.048l3.266 14.326a1.373 1.373 0 0 0 1.339 1.068h18.382c.882 0 1.535-.819 1.339-1.679zm-7.862-7.675-5.261 4.237a.902.902 0 0 1-1.272-.146l-2.067-2.637a.9.9 0 0 1 1.417-1.112l1.504 1.92 4.551-3.666a.901.901 0 0 1 1.266.137.905.905 0 0 1-.138 1.267zM7.15 23.553 4.479 11.835 3.56 15.86l-1.53 6.68c-.19.86.46 1.68 1.34 1.68h4.022a3.194 3.194 0 0 1-.242-.667z",
    fill: "#111f3e",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationIcon);
export default __webpack_public_path__ + "static/media/reservationIcon.6c212f8fab0ed394fbaec1185451a5de.svg";
export { ForwardRef as ReactComponent };